import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { DiseaseType, IcdCodeType } from "../../../constants/ICD10";
import ICD10 from "../components/ICD10";
import { DiseaseTypeResponse, IcdCodeTypeResponse } from "../../../models/api/ICD10";
import { getDiseaseTypeCall, getIcdCodeForReAuth, getIcdCodeTypeData } from "../../../actions/ICD10";
import { IcdCodeForReAuthPayload } from "../../../models/Patient";

const getIcdCodeType = (icdCodeTypeState: IcdCodeTypeResponse) => {
  const result = icdCodeTypeState.response;
  return result;
};

const getDiseaseType = (disaseTypeState: DiseaseTypeResponse) => {
  const result = disaseTypeState.response;
  return result;
};

const mapStateToProps = ({
  disaseTypeState,
  icdCodeTypeState,
  loggedInUserState,
  icdCodeForReAuthState,
  reAuthReferralDetailState,
  tabSessionStorageReAuthState
}: ApplicationState) => ({
  diseaseTypeResp: getDiseaseType(disaseTypeState) as DiseaseType[],
  icdCodeDataType: getIcdCodeType(icdCodeTypeState) as IcdCodeType[],
  loggedInUserState: loggedInUserState.response,
  icdCodeForReAuthState: icdCodeForReAuthState.response,
  reAuthReferralDetailState: reAuthReferralDetailState.response,
  tabSessionStorageReAuthState: tabSessionStorageReAuthState.response,

});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getIcdeCodeDataType: () => {
      dispatch(getIcdCodeTypeData());
    },
    getDiseaseTypeData: (diseaseIdentifier: string) => {
      dispatch(getDiseaseTypeCall(diseaseIdentifier));
    },
    getIcdCodeForReAuth: (payload: IcdCodeForReAuthPayload) => {
      dispatch(getIcdCodeForReAuth(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ICD10);